import { defineComponent as n, computed as l, openBlock as i, createElementBlock as c, createElementVNode as e, toDisplayString as h, createCommentVNode as d, normalizeStyle as _ } from "vue";
const m = ["viewBox"], f = /* @__PURE__ */ e("mask", { id: "0a572a95-48ac-4822-9549-626544928b75" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#0a572a95-48ac-4822-9549-626544928b75)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 256 256 0h256v512H0z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M0 0h256v256H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "m205 167 4.2 12.7h13.4l-10.8 7.9 4.1 12.7-10.8-7.8-10.9 7.8 4.1-12.7-10.8-7.9h13.4zM137.8 66.8l7 21.2H167l-18.1 13.2 6.9 21.2-18.1-13.1-18 13.1 6.8-21.2-18-13.2h22.3zM204.5 89l6.9 21.3h22.3l-18 13.1 6.9 21.3-18.1-13.1-18.1 13.1 7-21.3-18.2-13.1h22.4zm-52.8 89 6.9 21.3H181l-18.1 13.2 6.9 21.2-18.1-13.1-18 13.1 6.8-21.2-18-13.2h22.3zm-58.5-55.6 6.9 21.3h22.3l-18 13.1 6.9 21.3-18.1-13.2L75 178.1l6.9-21.3-18-13.1h22.3z"
}, null, -1), z = { fill: "none" }, w = ["r"], B = /* @__PURE__ */ n({
  __name: "ws",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, o = l(() => 512 + 2 * t.strokeWidth), s = l(() => -t.strokeWidth), a = l(() => 256 + t.strokeWidth / 2);
    return (x, y) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${o.value} ${o.value}`
    }, [
      f,
      e("g", u, [
        t.flagName ? (i(), c("title", k, h(t.flagName), 1)) : d("", !0),
        p,
        v,
        g
      ]),
      e("g", z, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, m));
  }
});
export {
  B as default
};
//# sourceMappingURL=ws-c3129edc.js.map
